export const ACTIVE_LIST = [
  1054003,
  1054007,
  1054012,
  1054013,
  1054014,
  1054069,
  1054015,
  1054016,
  1054017,
  // 1054071,
  1054070,
  1054012,
  1054013,
  1054040,
  1054041,
  1054042,
  1054018,
  1054019,
  1054030,
  1054032,
  1054051,
  1054052,
  1054059,
  1054060,
  1054063,
  1054068,
  1054005,
  // 1054011,
  1054050,
  // 1054038,
];

export const GRID_INFO = {
  resizable: true,
  border: true,
  showOverflow: true,
  highlightHoverRow: true,
  highlightCurrentRow: true,
  keepSource: true,
  // rowId: 'id',
  height: 590,

  exportConfig: {
    isAllExpand: true,
  },
  expandConfig: {
    expandAll: true,
    reserve: true,
  },
  columns: [],
};

export const TOOL_BAR = {
  print: false,
  export: true,
  zoom: true,
  custom: true,
  slots: {
    buttons: "toolbar_buttons",
    tools: "tools",
  },
};

export const SCHEDULE_SLOTS_LIST = [
  {
    id: "1054008", slots: {
      default: "cascadeShow",
      edit: "cascadeEdit",
    }
  },
  {
    id: "1054009", slots: {
      default: "startDateShow",
      edit: "startDateEdit",
    }
  },
  {
    id: "1054010", slots: {
      default: "endDateShow",
      edit: "endDateEdit",
    }
  },

  {
    id: "1054012", slots: {
      default: "startDateShowACT",
      edit: "startDateEditACT",
    }
  },
  {
    id: "1054013", slots: {
      default: "endDateShowACT",
      edit: "endDateEditACT",
    }
  },
  { id: "1054018", slots: { default: "actualCost" } },
  { id: "1054019", slots: { default: "budgetedCost" } },

  { id: "1054011", slots: { default: "duration", edit: "editDuration" } },
]


export const isArrEqual = (a, b) => {
  if (!Array.isArray(a) || !Array.isArray(b)) {
    return false;
  }

  if (a.length !== b.length) {
    return false;
  }

  let aa = true;
  for (let i = 0; i < a.length; i++) {
    const el = a[i];
    if (!b.includes(el)) {
      aa = false;
      break;
    }
  }
  return aa;
};

export const compareArr = (A, B) => {
  const a = A.split("."),
    b = B.split(".");

  if (A === "") {
    return false;
  }

  if (a.length !== b.length) {
    return false;
  }

  if (A.length === 0) {
    return true;
  }

  let T = true;

  for (let index = 0; index < a.length; index++) {
    const x = a[index] !== b[index];
    if (index !== a.length - 1 && x) {
      T = false;
      break;
    }
  }

  return T;
};

